import { Download } from 'lucide-react';

import { joinWithAnd } from './privateEventDisplay';

/**
 * Explains, once per page, why an imported event has gaps: the source never
 * had them. `missing` names each absent field ("the location", "the crew"),
 * and the sentence agrees with however many there are.
 */
export default function ImportedFromFareharborBanner({ missing }: { missing: string[] }) {
  const verb = missing.length > 1 ? 'were' : 'was';
  return (
    <div
      role="note"
      style={{
        display: 'flex',
        gap: 10,
        alignItems: 'flex-start',
        padding: '10px 14px',
        background: 'var(--nb-surface)',
        border: '1px solid var(--nb-border)',
        borderLeft: '3px solid var(--nb-border-2)',
        borderRadius: 8,
      }}
    >
      <Download
        size={15}
        aria-hidden
        style={{ marginTop: 1, flexShrink: 0, color: 'var(--nb-subtle)' }}
      />
      <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: 'var(--nb-muted)' }}>
        <strong style={{ color: 'var(--nb-ink-2)', fontWeight: 700 }}>
          Imported from FareHarbor.
        </strong>{' '}
        {sentenceCase(joinWithAnd(missing))} {verb} never recorded in the source system — nothing
        failed to load, and nobody here left it blank. Fill it in as the client confirms details.
      </p>
    </div>
  );
}

function sentenceCase(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
